/* eslint-disable max-len */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import moment from 'moment-timezone';
import Loader from '../Common/Loader';
// import { history } from '../../redux/store';
import { Link, useNavigate } from 'react-router-dom';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const RatePlanWrapper = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [mealList, setMealList] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageRangeDisplayed] = useState(5);
  const [counter, setCounter] = useState(0);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [searchParam, setSearchParam] = useState({
    name: '',
    mealplanId: 0,
    validFrom: '',
    validTo: '',
    minLos: '',
    maxLos: '',
    status: 2
  });

  useEffect(() => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    if (hotelId > 0) {
      getRatePlanList();
      getMealPlanList();
    }
    // eslint-disable-next-line
  }, []);

  const getMealPlanList = useCallback(() => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'common/mealplanlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId }
    })
      .then(response => {
        if (response.status === 200) {
          setMealList(response.data.mealPlanList);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  }, []);

  const getRatePlanList = useCallback(() => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'rateplan/rateplanlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId: hotelId,
        page: pageNumber,
        limit: limit,
        searchParam: searchParam
      }
    })
      .then(response => {
        if (response.status === 200) {
          setList(response.data);
          setTotal(response.data.count);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  }, [pageNumber, limit, searchParam]);

  const activeInactive = (rpId, status) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'rateplan/changestatus', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { rpId, status, hotelId }
    })
      .then(response => {
        if (response.data.status === 'success') {
          showMessage('success', response.data.message);
          setTimeout(() => {
            getRatePlanList();
          }, 500);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => {
      setFlag(false);
    }, 5000);
  };

  const editRatePlan = (rpId) => {
    navigate('/rateplan/editrateplan/' + rpId);
  };

  const handlePageChange = (pageNum) => {
    const newCounter = pageNum <= 1 ? 0 : (pageNum - 1) * limit;
    setPageNumber(pageNum);
    setCounter(newCounter);
  };

  useEffect(() => {
    getRatePlanList();
    // eslint-disable-next-line
  }, [pageNumber, searchParam]);

  const dateChange = (date, type) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    setSearchParam(prev => ({ ...prev, [type]: newDate }));
  };

  const paramChange = (e, type) => {
    setSearchParam(prev => ({ ...prev, [type]: e.target.value }));
  };

  const statusFilter = (val) => {
    setSearchParam(prev => ({ ...prev, status: val }));
  };

  const renderSeason = (season, className, all) => {
    var seasons = [];
    season.map((val, id) => {
      if (!all && id > 1) {
        return '';
      }
      seasons.push(
        <div className={className} key={id}>
          {val}
        </div>
      );
    });
    return seasons;
  };

  const search = () => {
    var flag = true;
    var msg = 'Please Select Criteria for search.';
    if (searchParam.mealplanId > 0) {
      flag = false;
    }
    if (searchParam.name !== '') {
      flag = false;
    }
    if (searchParam.validFrom !== '') {
      flag = false;
    }
    if (searchParam.validTo !== '') {
      flag = false;
    }
    if (searchParam.minLos !== '') {
      flag = false;
    }
    if (searchParam.maxLos !== '') {
      flag = false;
    }
    if (flag) {
      setFlag(true);
      setType('error');
      setMessage(msg);
      setTimeout(() => {
        setFlag(false);
      }, 5000);
    } else {
      setPageNumber(1);
      setCounter(0);
      getRatePlanList();
    }
  };

  const reset = () => {
    setSearchParam({
      name: '',
      mealplanId: 0,
      validFrom: '',
      validTo: '',
      minLos: '',
      maxLos: '',
      status: 1
    });
    setPageNumber(1);
    setCounter(0);
    getRatePlanList();
  };

  const renderRatePlanList = () => {
    if (Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        return (
          <div className="table_row border_t_1 border_color_1" key={id}>
            <div className="tabcel align_middle pad10">{Number(counter + Number(Number(id) + 1))}</div>
            <div className="tabcel align_middle pad10">
              <span title="Rateplan name">{data.rate_plan_name}</span>{' '}
              <span title="Rateplan code">{data.rate_plan_code ? '(' + data.rate_plan_code + ')' : ''}</span>
            </div>
            <div className="tabcel align_middle pad10">
              <div className="ovr">
                <div className="inline marg_right15">
                  {data.seasons.length > 0 ? renderSeason(data.seasons, 'ovr', false) : ''}
                </div>
                {data.seasons.length > 2 ? (
                  <div className="inline offset_wrap">
                    <div className="ovr cursor_p offset_btn">
                      <span className="icon_size3 bg2_12 full-round marg_right5">
                        <i className="fa fa-ellipsis-h icon_center"></i>
                      </span>
                    </div>
                    <div className="offset_append ovr hides">
                      <div className="cover wdhpx200 pad10 bg1">
                        <div className="cover">{renderSeason(data.seasons, 'ovr marg_bottom7', true)}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className="tabcel align_middle pad10">{data.currency}</div>
            <div className="tabcel align_middle pad10">{data.meal_plan_name}</div>
            <div className="tabcel align_middle pad10">
              <div className="ovr"> Min : {data.minimum_length_stay}</div>
              <div className="ovr"> Max : {data.maximum_length_stay === 0 ? 'Unlimited' : data.maximum_length_stay}</div>
            </div>
            <div className="tabcel align_middle pad10">
              <div className="row">
                <div className="col-xs tc">
                  <i
                    className="fa fa-pencil fnt15 color7 cursor_p"
                    title="Edit"
                    onClick={() => editRatePlan(data.rate_plan_id)}
                  ></i>
                </div>
                {/* <div className="col-xs tc">
                  <i
                    className={`fa fa-shield fnt15 cursor_p ${data.status === 1 ? 'color4_1' : 'color5_2'}`}
                    title={data.status === 1 ? 'InActive' : 'Active'}
                    onClick={() => activeInactive(data.rate_plan_id, data.status)}
                  ></i>
                </div> */}
              </div>
            </div>
          </div>
        );
      });
    }
  };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">RATE PLANS</div>
          </div>
          <div className="col-xs-auto"></div>
        </div>
      </div>
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scroll_770">
            <div className="scroll_inner_770">
              <div className="table_col table_fixed">
                <div className="table_row bg2_8 bdr1_b">
                  <div className="tabcel align_middle pad10 wdhpx60">S.No.</div>
                  <div className="tabcel align_middle pad10"> Rate Plan</div>
                  <div className="tabcel align_middle pad10"> Travel Date</div>
                  <div className="tabcel align_middle pad10"> Currency</div>
                  <div className="tabcel align_middle pad10">Meal Plan</div>
                  <div className="tabcel align_middle pad10"> LOS</div>
                  <div className="tabcel align_middle pad10 wdhpx100 tc"> Action</div>
                </div>
                {renderRatePlanList()}
              </div>
            </div>
            {total === 0 && !showUILoader ? (
              <div className="cover pad30 border_t_1 border_color_1">
                <div className="ovr tc marg_bottom10">
                  <div className="inline">
                    <img src="../../../assets/images/no_result.png" alt="No Booking Found" />
                  </div>
                </div>
                <div className="ovr tc fnt16 bld">No Rateplan Found</div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={pageRangeDisplayed}
              onChange={handlePageChange}
            /> */}
          </div>
        ) : (
          ''
        )}
      </div>
    </React.Fragment>
  );
};

export default RatePlanWrapper;
